import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
  voucherPath: any,
  remarks: string,
  property_id: string,
  paymentMethod: any,
  transaction_id: any,
  image: any
}

@Component({
  selector: 'app-edit-property-payment',
  templateUrl: './edit-property-payment.component.html',
  styleUrls: ['./edit-property-payment.component.css']
})
export class EditPropertyPaymentComponent {

  imgURL: any

  paymentMethods = [
    {value: 'Pay In Cash'},
    {value: 'Transferred to Bank'},
    {value: 'esewa'},
    {value: 'Bank Payment'}
  ]

  basicInfoForm: FormGroup = new FormGroup({
    voucherPath: new FormControl(null, [Validators.required]),
    remarks: new FormControl('', [Validators.required]),
    property_id: new FormControl('', [Validators.required])
  })

  transactionForm: FormGroup = new FormGroup({
    paymentMethod: new FormControl(null, [Validators.required]),
    transaction_id: new FormControl('', [Validators.required]),
    property_id: new FormControl('', [Validators.required]),
    voucherPath: new FormControl(null),
  })

  selectedPayment: string

  adPlans = []

  constructor(
    public dialogRef: MatDialogRef<EditPropertyPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

      this.transactionForm.setValue({
        paymentMethod: this.data.paymentMethod,
        transaction_id: this.data.transaction_id,
        property_id: this.data.property_id,
        voucherPath: this.data.voucherPath,
      })

      this.basicInfoForm.setValue({
        voucherPath: this.data.voucherPath,
        remarks: this.data.remarks,
        property_id: this.data.property_id
      })

      if(this.data.voucherPath && (! this.data.transaction_id)){
        this.selectedPayment = 'Bank Payment'
        this.imgURL = data.image
        delete data['image']
      }

      if(this.data.voucherPath && this.data.transaction_id && (this.data.paymentMethod != 'Pay In Cash')){
        this.imgURL = data.image
        delete data['image']
      }

      if(this.data.paymentMethod && this.data.transaction_id){
        if(this.data.paymentMethod != 'Pay In Cash' && this.data.paymentMethod != 'esewa'){
          this.selectedPayment = 'Transferred to Bank'
        }else{
          this.selectedPayment = this.data.paymentMethod
        }
      }
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
    if(filesize <= 8){
      this.basicInfoForm['controls']['voucherPath'].setValue(image)
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.imgURL = reader.result; 
      }
    }
  }

  fileChangeEvent1(event: any){
    let image = event.target.files[0]
    var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
    if(filesize <= 8){
      this.transactionForm['controls']['voucherPath'].setValue(image)
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.imgURL = reader.result; 
      }
    }
  }

  saveTransactionInfo(){
    if(this.selectedPayment == 'Bank Payment'){
      if(this.basicInfoForm.valid){
        let basicInfo = this.basicInfoForm.value
        basicInfo['selectedPayment'] = 'bankPayment'
        this.dialogRef.close(basicInfo)
      }
    }else{
      if(this.selectedPayment == 'esewa'){
        this.transactionForm.controls['paymentMethod'].setValue('esewa')
      }else if(this.selectedPayment == 'Pay In Cash'){
        this.transactionForm.controls['paymentMethod'].setValue('Pay In Cash')
      }
      if(this.transactionForm.valid){
        let transactionInfo = this.transactionForm.value
        transactionInfo['selectedPayment'] = 'transaction'
        // if(transactionInfo.paymentMethod == 'Pay In Cash'){
        //   delete transactionInfo['voucherPath']
        // }
        this.dialogRef.close(transactionInfo)
      }
    }
    
  }
}
